export default __webpack_public_path__ + "static/media/curology-min.b052d80b.png";